// NPM Imports
// Quote Context
// Component Imports
// JS Imports
// Asset Imports

export default function LoadingScreen() {
   return (
      <div
         className='h-100 d-flex align-items-center justify-content-center'
         id='LoadingScreen'
      >
         Loading product and discount data.
      </div>
   )
}
